
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconCardinalNorth as ObiSimplifiedBeaconCardinalNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-cardinal-north.js';
 
 
 

 
 export const ObiSimplifiedBeaconCardinalNorth = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-cardinal-north',
   elementClass: ObiSimplifiedBeaconCardinalNorthElement,
   events: {
     
   }
  });
 
 